class FeaturedSlider extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.gridActive = false;
    this.sliderActive = true;
    this.totalSlides = 0;
  }

  connectedCallback() {
    this.initializeSlider();
    this.setupEventListeners();
    this.tabSwitch(); // Initialize tab switching functionality

    // Listen for URL changes
    window.addEventListener('hashchange', () => this.handleHashChange());

    // Call this immediately to check if there's an initial hash in the URL
    this.handleHashChange();
  }

  initializeSlider() {
    this.slider = this.querySelector(".featured-suits--tab-content-wrapper.active");
    this.slides = this.slider.querySelectorAll(".featured-suits--card");
    this.totalSlides = this.slides.length;
    this.leftArrow = this.querySelector(".featured-suits--left-arrow");
    this.rightArrow = this.querySelector(".featured-suits--right-arrow");

    // Set up the initial state and update the arrows
    this.updateSlider();
    this.updateArrows(); // Update arrow visibility/disabled state
  }

  setupEventListeners() {
    if (this.leftArrow && this.rightArrow) {
      this.leftArrow.addEventListener("click", () => this.handleLeftClick());
      this.rightArrow.addEventListener("click", () => this.handleRightClick());
    }

    // Handle slider to grid transformation and vice versa
    const gridButton = this.querySelector(".featured-suits--grid-transform-button");
    const sliderButton = this.querySelector(".featured-suits--slider-transform-button");

    if (gridButton) {
      gridButton.addEventListener("click", () => this.activateGrid());
    }

    if (sliderButton) {
      sliderButton.addEventListener("click", () => this.activateSlider());
    }
  }

  updateSlider() {
    const slideWidth = this.slides[0].offsetWidth;
    const offset = -this.currentIndex * (slideWidth + 8);
    this.slides.forEach((item) => {
      item.style.transform = `translateX(${offset}px)`;
    });
  }
  
  updateArrows() {
    // Hide/show arrows based on whether we're in grid or slider view
    if (this.gridActive) {
      this.leftArrow.classList.add('hide-arrows');
      this.rightArrow.classList.add('hide-arrows');
    } else {
      this.leftArrow.classList.add('display-arrows');
      this.rightArrow.classList.add('display-arrows');

      if (this.totalSlides > 3){
        this.rightArrow.classList.add('display-arrows');
        this.leftArrow.classList.add('display-arrows');
        this.rightArrow.classList.remove('hide-arrows');
        this.leftArrow.classList.remove('hide-arrows');
      }
      else{
        this.rightArrow.classList.add('hide-arrows');
        this.leftArrow.classList.add('hide-arrows');
        this.rightArrow.classList.remove('display-arrows');
        this.leftArrow.classList.remove('display-arrows');
      }

      // Disable left arrow if at the first slide
      if (this.currentIndex === 0) {
        this.leftArrow.setAttribute("disabled", true);
        this.leftArrow.querySelector("svg path").setAttribute("stroke", "grey");
      } else {
        this.leftArrow.removeAttribute("disabled");
        this.leftArrow.querySelector("svg path").setAttribute("stroke", "black");
      }

      // Disable right arrow if at the last slide
      if (this.currentIndex >= this.totalSlides - 2) {
        this.rightArrow.setAttribute("disabled", true);
        this.rightArrow.querySelector("svg path").setAttribute("stroke", "grey");
      } else {
        this.rightArrow.removeAttribute("disabled");
        this.rightArrow.querySelector("svg path").setAttribute("stroke", "black");
      }
      
    }
  }

  handleLeftClick() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateSlider();
      this.updateArrows(); // Update arrows after moving
    }
  }

  handleRightClick() {
    if (this.currentIndex < this.totalSlides - 2) {
      this.currentIndex++;
      this.updateSlider();
      this.updateArrows(); // Update arrows after moving
    }
  }

  activateGrid() {
    const activeTabContent = this.querySelector(".featured-suits--tab-content-wrapper.active");
    this.currentIndex = 0;
    this.querySelectorAll(".featured-suits--card").forEach((item) => {
      item.style.transform = `translateX(0px)`;
      item.classList.add('grid-show-width');
    });
    activeTabContent.style.flexWrap = "wrap";
    this.querySelector(".featured-suits--slider-transform-button").classList.remove("active");
    this.querySelector(".featured-suits--grid-transform-button").classList.add("active");
    this.gridActive = true;
    this.sliderActive = false;

    // Hide the arrows in grid view
    this.updateArrows();
  }

  activateSlider() {
    this.currentIndex = 0;
    this.querySelectorAll(".featured-suits--card").forEach((item) => {
      item.style.transform = `translateX(0px)`;
      item.classList.remove('grid-show-width');
    });
    const activeTabContent = this.querySelector(".featured-suits--tab-content-wrapper.active");
    activeTabContent.style.flexWrap = "nowrap";
    this.querySelector(".featured-suits--grid-transform-button").classList.remove("active");
    this.querySelector(".featured-suits--slider-transform-button").classList.add("active");
    this.gridActive = false;
    this.sliderActive = true;

    // Show the arrows in slider view
    this.updateSlider();
    this.updateArrows();
  }

  tabSwitch() {
    this.querySelectorAll(".featured-suits--tab-labels-wrapper").forEach((item) => {
      item.addEventListener("click", () => {
        this.switchTab(item);
      });
    });
  }

  switchTab(item) {
    // Remove active class from all tab labels and tab contents
    this.querySelectorAll(".featured-suits--tab-labels-wrapper.active").forEach((tab) => {
      tab.classList.remove("active");
    });
    this.querySelectorAll(".featured-suits--tab-content-wrapper.active").forEach((tabContent) => {
      tabContent.classList.remove("active");
    });

    // Activate the clicked tab and its content
    item.classList.add("active");
    const label = item.getAttribute("data-block-label");
    const newActiveTab = this.querySelector(`[data-block-title="${label}"]`);
    newActiveTab.classList.add("active");

    if (this.gridActive) {
      this.activateGrid();
    } else {
      this.activateSlider();
    }

    // Update the URL with the label name
    const labelName = this.formatLabel(item.querySelector('.featured-suits--tab-label').textContent);
    window.location.hash = labelName;

    // Reinitialize slider
    this.initializeSlider();
  }

  formatLabel(label) {
    return label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  handleHashChange() {
    const hash = window.location.hash.slice(1); // Get the hash without the `#`
    
    // Check if the hash matches any tab label
    this.querySelectorAll(".featured-suits--tab-labels-wrapper").forEach((item) => {
      const labelName = this.formatLabel(item.querySelector('.featured-suits--tab-label').textContent);
      
      if (labelName === hash) {
        // Activate the tab and content matching the URL hash
        this.switchTab(item);
      }
    });
  }
}

// Register the custom element
customElements.define('featured-slider', FeaturedSlider);


